module.exports = __webpack_public_path__ + "img/black-card-with-logo.1816acbb.png";